import script from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./InfoPanel.vue?vue&type=style&index=0&id=17b03584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b03584"]])

export default __exports__